
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';

export default BaseCmsBlock.extend({
    name: 'DocumentsBlock',

    data() {
        return {
            activeSlide: 1,
            swiperOptions: {
                spaceBetween: 30,
                slidesPerView: 1.4,
                slidesPerGroup: 1,

                loop: true,

                navigation: {
                    prevEl: '.documents-block__button-navition--prev',
                    nextEl: '.documents-block__button-navition--next',
                },
                breakpoints: {
                    860: {
                        paceBetween: 30,
                        slidesPerView: 3.2,
                        slidesPerGroup: 1,
                    },
                },
            },

        };
    },

    components: {
        DocumentCard: () => import('./components/DocumentsBlock/DocumentCard.vue'),
        Swiper,
        SwiperSlide,
    },

    methods: {
        slideChange() {
            this.activeSlide = this.$refs.refSwiper.$swiper.activeIndex + 1;
        },

    },
});
